export default __webpack_public_path__ + "c414ef8e9ede2d04cf1180d0d9ff7170.svg";